export default function isMac() {
  return navigator.platform.includes("Mac");
}
